import Ajv from 'ajv';
import ajvErrors from 'ajv-errors';
import ajvFormats from 'ajv-formats';

// Shared form compiler: allErrors enables localized messages; $data enables cross-field rules.
const ajv = new Ajv({
  allErrors: true,
  removeAdditional: true,
  useDefaults: true,
  coerceTypes: true,
  // Decimal multipleOf rules allow binary floating-point noise.
  multipleOfPrecision: 10,
  $data: true,
});
ajvErrors(ajv);
ajvFormats(ajv);

const compiledSchemas = new Map();

export const getCompiledSchema = (schema) => {
  const schemaKey = JSON.stringify(schema);
  let validateSchema = compiledSchemas.get(schemaKey);
  if (!validateSchema) {
    validateSchema = ajv.compile(schema);
    compiledSchemas.set(schemaKey, validateSchema);
  }
  return validateSchema;
};

export default ajv;
